// ModalToast.jsx
const ModalToast = ({ message, type, onClose }) => {
    
  return (
    <div className="modal-toast-backdrop">
      <div className={`modal-toast modal-${type}`}>
        <p>{message}</p>
        <button className="border-1 py-1 mt-5 px-5 bg-blue-700 text-xs text-white" onClick={onClose}>OK</button>
      </div>
    </div>
  );
};

export default ModalToast;
